<div
  class="modal-backdrop"
  *ngIf="isOpen"
  (click)="onBackdropClick()"
>
  <div
    class="modal-wrapper"
    (click)="$event.stopPropagation()"
  >
    <div class="modal-window" role="dialog" aria-modal="true" aria-labelledby="terms-heading" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">

      <!-- MOBILE -->
      <div class="mobile-terms">
        <div class="mobile-terms__heading">
          <img
            class="mobile-terms__heading-icon"
            src="assets/icons/terms.svg"
            width="16"
            height="19"
            alt=""
          />

          <h2 id="terms-heading">
            {{ languageService.translate([
            'Terms & Conditions',
            'Условия и положения'
          ]) }}
          </h2>
          <button class="desktop-terms-close" type="button" [attr.aria-label]="languageService.translate(['Close', 'Закрыть'])" (click)="close()">×</button>
        </div>

        <p class="mobile-terms__description">
          {{
            languageService.translate([
              'Review the terms of your selected service before continuing with your booking.',
              'Текст условий предоставления выбранной услуги. Ознакомьтесь с правилами до продолжения оформления.'
            ])
          }}
        </p>
        @if (service?.title) { <p class="terms-service-name">{{ service?.title }}</p> }

        <div class="mobile-terms__time">
          <img
            src="assets/icons/thunder.svg"
            width="13"
            height="21"
            alt=""
          />

          <span>48h</span>
        </div>

        <p class="mobile-terms__description">
          {{
            languageService.translate([
              'Additional conditions and fees may apply to urgent bookings made less than 48 hours in advance.',
              'При срочном бронировании менее чем за 48 часов могут применяться дополнительные условия и сборы.'
            ])
          }}
        </p>

        <button
          class="mobile-terms__okay"
          type="button"
          (click)="accept()"
        >
          {{ languageService.translate([
          'Okay',
          'Хорошо'
        ]) }}
        </button>
      </div>

    </div>
  </div>
</div>
